import polygonDialog from "./polygonDialog";
import canvasMessages from "./canvasMessages";
import contextMenuList from "./contextMenuList";
import treeRender from "./treeRender";
import nodeStyle from "./nodeStyle";

export default {
  loading: {
    text: "拼命載入中",
  },
  // TopSearch.vue - 顶部时间搜索
  topSearch: {
    transactionTime: "交易時間",
    startDatePlaceholder: "開始日期",
    endDatePlaceholder: "結束日期",
  },
  // setupConfigure.vue - 設置配置
  setupConfigure: {
    title: "設置",
    transactionQuantityLabel: "交易數量（單筆交易）",
    minAmountPlaceholder: "最小金額",
    maxAmountPlaceholder: "最大金額",
    transactionTimeLabel: "交易時間",
    startDatePlaceholder: "開始日期",
    endDatePlaceholder: "結束日期",
    advancedSettingsTitle: "高級設置",
    expandCountLabel: "擴展對手數",
    expandCountPlaceholder: "1-100",
    expandCountError: "請填寫1-100之間的整數",
    repeatAddressLabel: "重複地址標識",
    firstInflowEnable: "首筆主幣流入",
    cancelBtn: "取消",
    confirmBtn: "確認",
  },
  // LeftOperation.vue - 左側操作
  leftOperation: {
    settingsTooltip: "設置",
    aiModelTooltip: "AI模型",
    investigationTooltip: "調證",
  },
  // BTCAddress.vue - BTC地址詳情
  btcAddress: {
    title: "地址詳情",
    loadingText: "拼命載入中",
  },
  // BottomOperation.vue - 底部操作
  bottomOperation: {
    backToCenterTooltip: "回到中心",
    previousStepTooltip: "上一步",
    nextStepTooltip: "下一步",
    saveCanvasTooltip: "保存畫布",
    fullscreenTooltip: "全屏",
    exitFullscreenTooltip: "取消全屏",
  },
  dialog: {
    canvasDownload: "畫布下載",
    remark: "備註",
    addMonitoring: "新增監控",
    tip: "提示",
  },
  tips: {
    svgViewerTip:
      "為了獲得最佳的檢視體驗，建議使用 Google Chrome 或 Microsoft Edge 瀏覽器開啟SVG格式檔案",
    verificationResult: "已有驗證結果",
    switchCurrencyWarning: "切換幣種後目前畫布將不存在，是否需要儲存畫布？",
    searchAddressWarning:
      "搜尋位址在畫布中不存在，重新搜尋後會開啟新的畫布，是否需要儲存目前畫布？",
  },
  buttons: {
    confirmDownload: "確認下載",
    close: "關閉",
    cancel: "取 消",
    confirm: "確 定",
    notSave: "不儲存",
    saveCanvas: "儲存畫布",
    closeDialog: "關閉彈窗",
    viewVerification: "檢視驗證結果",
  },
  placeholders: {
    remarkInput: "請輸入備註內容",
  },
  messages: {
    setupSuccess: "設定成功",
    createCanvasSuccess: "新建畫布成功",
    saveSuccess: "儲存成功",
    cancelled: "已取消",
  },
  titles: {
    modifyInfo: "修改資訊",
  },
  canvasHeader: {
    unnamedCanvas: "未命名畫布",
    singleCurrencyCanvas: "單幣種畫布",
    caseLabel: "案件：",
    selectCurrencyPlaceholder: "請選擇幣種",
    searchPlaceholder: "搜尋地址/哈希",
    startAnalysis: "開始分析",
    shortcutKeys: "快捷鍵說明",
    svgFormat: "SVG格式",
    pngFormat: "PNG格式",
    xmindFormat: "XMIND格式",
    refresh: "刷新",
    save: "儲存",
    shortcutKeysTitle: "畫布操作快捷鍵說明",
    shortcuts: {
      copyNode: "複製節點",
      previousStep: "上一步",
      nextStep: "下一步",
      saveCanvas: "儲存畫布",
      createCanvas: "新建畫布",
      nodeRemark: "節點備註",
      viewNodeDetail: "檢視節點詳情（選取單個點）",
      exitFullscreen: "退出畫布全螢幕",
      addMonitoring: "加入監控",
    },
  },
  // modeldetail.vue - AI模型詳情
  modelDetail: {
    title: "AI模型",
    loadingText: "拼命載入中",
    emptyText: "暫無數據",
    modelVerificationType: "模型驗證類型：",
    feeModel: "手續費模型",
    verificationResult: "驗證結果：",
    firstFeeSourceLevel: "首筆手續費來源層級：",
    feeSourceLevel: "手續費來源層級：",
    firstFeeSourcePlatform: "首筆手續費來源平台：",
    firstFeeSourceAddress: "首筆手續費來源地址：",
    feeSourceAddress: "手續費來源地址：",
    firstFeeSourceHash: "首筆手續費來源hash：",
    feeSourceHash: "手續費來源hash：",
    firstFeeSourceTime: "首筆手續費來源時間：",
    feeSourceTime: "手續費來源時間：",
    firstFeeSourceQuantity: "首筆手續費來源數量：",
    feeSourceQuantity: "手續費來源數量：",
    ordinaryInvestigation: "普通調證",
    keyInvestigation: "重點調證",
    copySuccess: "複製成功",
    addInvestigationSuccess: "加入調證成功",
  },
  // nodedetail.vue - 節點詳情
  nodeDetail: {
    loadingText: "拼命載入中",
    addressDetail: "地址詳情",
    nodeDetail: "節點詳情",
    contractDetail: "合約詳情",
    transactionStatistics: "交易統計",
    tradingOpponent: "交易對手",
    tradingOpponentWithUSDT: "交易對手(USDT)",
    otherInfo: "其他信息",
    assets: "資產",
    notSupportedBlockchain: "系統暫不支持此鏈上的數據展示",
    addressNotFound: "沒有查出該地址",
    noTransactionData: "系統中沒有當前地址的交易數據",
  },
  polygonDialog,
  canvasMessages,
  contextMenuList,
  treeRender,
  nodeStyle,
};
